import { Loading } from '@op/opds.opux';
import { useEffect } from 'react';
import styles from './RatingLoading.module.scss';
import ratingLoadingImage from 'assets/ratingLoading.svg';
import { useAutofocus } from 'hooks';
import i18n from 'i18n';

const RatingLoading = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const ratingLoadingRef = useAutofocus<HTMLParagraphElement>();
  return (
    <div className={styles.ratingLoadingWrapper}>
      <div className={styles.ratingLoadingContainer}>
        <Loading
          size={96}
          data-testid='loading-screen'
          className={styles.spinner}
        />
        <p
          className={styles.ratingLoadingText}
          ref={ratingLoadingRef}
          tabIndex={-1}>
          {i18n.t('common.ratingLoadingText')}
        </p>
        <img
          className={styles.ratingLoadingImage}
          role='presentation'
          src={ratingLoadingImage}
          alt={i18n.t('common.ratingLoadingText')}
        />
      </div>
    </div>
  );
};

export default RatingLoading;
